<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {
  getAddressOptions, getOrgOptions,
} from '@qx/utils';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [],
        trailerMaterialOptions: [],
        isStateOptions: [],
        form: [{
          label: '车牌号码',
          value: 'trailerNumber',
          type: 'input',
          placeholder: '请输入车牌号码',
        },
        {
          label: '挂车材质',
          value: 'trailerMaterial',
          type: 'select',
          default: '-1',
        },
        {
          label: '归属部门',
          value: 'orgId',
          type: 'select',
          default: '-1',
        },
        {
          label: '起始位置',
          value: 'position',
          type: 'cascader',
          options: getAddressOptions({
            showLevel: 1,
          }),
        }, {
          label: '当前状态',
          value: 'isState',
          type: 'select',
          placeholder: '请选择状态',
        }],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.position.length) {
        searchBoxData.sourceProvince = searchBoxData.position[0]; // 省
        searchBoxData.sourceRegion = searchBoxData.position[1]; // 市
        searchBoxData.sourceCounty = searchBoxData.position[2]; // 区
      }
      searchBoxData.deleteFlag = 9;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'TRAILER_MATERIAL,TRAILER_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.trailerMaterialOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.isStateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(1),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...((await getDepartmentAllList({
        isArchive: true,
      })) || []),
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
